import { render, staticRenderFns } from "./ModalImportDiscounts.vue?vue&type=template&id=2d7fd209"
import script from "./ModalImportDiscounts.vue?vue&type=script&lang=js"
export * from "./ModalImportDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports